export const shipping = {
    cz: [
        { size: '0 - 50', price: 90 },
        { size: '50 - 120', price: 120 },
    ],
    sk: [
        { size: '0 - 50', price: '100 CZK / 5 €' },
        { size: '50 - 120', price: '130 CZK / 6 €' },
    ],
}
